import Vue from 'vue'
import moment from 'moment'

Vue.mixin({
  methods: {
    openChat(roomId) {
      const url = `/chat/${roomId}`
      window.open(
        url,
        'Chat',
        'top=0,left=0,width=400,height=600,status=no,toolbar=no,location=no,menubar=no,titlebar=no'
      )
    },
    openDirectChat(userId) {
      const url = `/chat/direct/${userId}`
      window.open(
        url,
        'Chat',
        'top=0,left=0,width=400,height=600,status=no,toolbar=no,location=no,menubar=no,titlebar=no'
      )
    },
    momentize(date) {
      return moment(date)
    },
    changeRoute(route) {
      this.$router.push(route)
    },
    getRouteParam(name) {
      const parseIntIfInt = val => (/^\d+$/.test(val) ? parseInt(val) : val)
      const param = this.$route.params[name]
      if (param) {
        return parseIntIfInt(param)
      }
    },
    getQueryParam(name) {
      const value = this.$route.query[name]
      const parseIntIfInt = val => (/^\d+$/.test(val) ? parseInt(val) : val)
      return Array.isArray(value)
        ? value.map(parseIntIfInt)
        : parseIntIfInt(value)
    },
    setQueryParam(name, value) {
      const oldQueryParams = this.$route.query
      if (oldQueryParams[name] !== value) {
        const newQueryParams = { ...oldQueryParams }
        if (value === undefined) {
          delete newQueryParams[name]
        } else {
          newQueryParams[name] = value
        }
        this.$router.push({ query: newQueryParams })
      }
    },
    tagColor(is_paid) {
      return is_paid ? 'green' : 'orange'
    },
    getTimespanFormatted(timespan) {
      if (!timespan) {
        return ''
      }
      const lower = moment(timespan.lower)
      const upper = moment(timespan.upper)
      return `${lower.format('DD.MM.YYYY')} <strong>${lower.format(
        'HH:mm'
      )} – ${upper.format('HH:mm')}</strong>`
    },
    getDateAndTime(datetime) {
      return `${this.getDateOnly(datetime)} godz. ${this.getTimeOnly(datetime)}`
    },
    getDateOnly(datetime) {
      return moment(datetime).format('YYYY-MM-DD')
    },
    getTimeOnly(datetime) {
      return moment(datetime).format('H:mm')
    },
    getNextDate(date) {
      return moment(date)
        .clone()
        .add(this.form.interval, 'days')
    },
    routeForUser(route, userType) {
      const parentRoute = route.matched[0]
      if (!parentRoute) {
        return false
      }
      if (!parentRoute.meta.allowedUserTypes) {
        return true
      } else {
        return parentRoute.meta.allowedUserTypes.includes(userType)
      }
    },
    getStatusTagMap() {
      return {
        available: {
          color: 'cyan',
          label: 'Dostępność'
        },
        confirmed: {
          color: 'green',
          label: 'Zatwierdzona'
        },
        pending: {
          color: 'yellow',
          label: 'Oczekuje na zatwierdzenie'
        },
        cancelled_and_charged: {
          color: 'red',
          label: 'Anulowane'
        },
        cancelled: {
          color: 'red',
          label: 'Anulowane'
        },
        declined: {
          color: 'red',
          label: 'Rezerwacja odrzucona'
        }
      }
    },
    browserNotify(title, content, icon) {
      const options = {
        body: content,
        icon
      }

      if (!('Notification' in window)) {
        return
      } else if (Notification.permission === 'granted') {
        new Notification(title, options)
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission(permission => {
          if (permission === 'granted') {
            new Notification(title, options)
          }
        })
      }
    },
    downloadBlobResponse(response) {
      const successStatusCodes = [201, 200]
      if (successStatusCodes.includes(response.status)) {
        const disposition = response.headers['content-disposition']
        const filenameRegex = /filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/
        const filename = disposition.match(filenameRegex)[1]
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }
    },
    getIntervalLabel(timespan, interval) {
      if (interval === 1) {
        return 'codziennie'
      } else if (interval === 7) {
        const weekday = timespan[0].format('dddd')
        const adverb = weekday === 'wtorek' ? 'we' : 'w'
        return `co tydzień ${adverb} ${weekday}`
      } else if (interval === 14) {
        const weekday = timespan[0].format('dddd')
        const adverb = weekday === 'wtorek' ? 'we' : 'w'
        return `co dwa tygodnie ${adverb} ${weekday}`
      }

      return ''
    },
    stripMinuteAndSeconds(momentObj) {
      return momentObj.clone().set({
        minute: 0,
        seconds: 0
      })
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    userType() {
      return this.userInfo.user_type
    },
    isAdmin() {
      return this.userType === 'superuser'
    },
    isLecturer() {
      return this.userType === 'lecturer'
    },
    isStudent() {
      return this.userType === 'student'
    },
    defaultRoute() {
      let url
      if (this.$route.query.next) {
        url = this.$route.query.next
      } else if (this.isAdmin) {
        url = '/admin/dashboard/'
      } else if (this.isLecturer) {
        url = '/lektor/dashboard/'
      } else if (this.isStudent) {
        url = '/kursant/dashboard/'
      } else {
        url = '/kursant/dashboard/'
      }
      return url
    }
  },
  beforeRouteLeave(to, from, next) {
    // if on page is ref=form check isDirty flag and avoid changes lost
    const form = this.$refs.form
    if (!form) {
      next()
      return
    }
    if (form.isDirty) {
      this.$confirm({
        title: 'Niezapisane zmiany',
        maskClosable: true,
        content:
          'Jeśli nie chcesz utracić wprowadzonych zmian kontynuuj edycję i kliknij "Zapisz" u dołu ekranu.',
        okText: 'Kontynuuj edycję',
        cancelText: 'Nie zapisuj zmian',
        onOk() {},
        onCancel() {
          next()
        }
      })
    } else {
      next()
    }
  },
  beforeCreate() {
    // queryModels is list with dynamic query-model params
    const keys = this.$options.queryModels
    if (!keys) {
      return
    }
    keys.forEach(key => {
      this.$options.computed[key] = {
        get() {
          return this.getQueryParam(key)
        },
        set(value) {
          // reset page if filters changed
          if (key !== 'page') {
            this.setQueryParam('page')
          }
          this.setQueryParam(key, value)
        }
      }
    })
  }
})
